<template>
    <v-app>

        <app-header v-if="hasHeader"></app-header>
        <v-main>
            <app-navbar v-if="hasSidebar"></app-navbar>
            <v-container>
                <router-view></router-view>
            </v-container>
        </v-main>
        <app-footer v-if="hasHeader"></app-footer>
        <access-denied-modal :open="accessModal"></access-denied-modal>
    </v-app>
</template>

<script>
    import AppHeader from '../components/header/Header'
    import AppNavbar from '../components/nav/Nav'
    import AppFooter from '../components/footer/Footer'
    import {InfoService, NavigationService} from "../services";

    import { noHeaderRoutes, noSidebarRoutes } from "../routes"
    import { AccessDeniedModal } from "../components/modals"

    export default {
        name: "App",
        components: {
            AppHeader,
            AppNavbar,
            AppFooter,
            AccessDeniedModal
        },
        data(){
            return {

            }
        },
        computed: {
            hasHeader() {
                return !noHeaderRoutes.find(item => item === this.$route.name);
            },
            hasSidebar() {
                return !noSidebarRoutes.find(item => item === this.$route.name);
            },
            accessModal() {
                return this.$store.getters.accessModal;
            }
        },
        methods: {
            setMainMenu() {
                NavigationService.setAuth(this.$store.getters.token);
                NavigationService.mainMenu()
                    .then(res => {
                        this.$store.commit('setMainMenu', res.data);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
        },
        created() {
            this.setMainMenu();
        }
    }
</script>

<style scoped>

</style>
